/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPauseIcon20Light = forwardRef('MediaUiAPauseIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8 3.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0v-13Z" }),
        React.createElement("path", { d: "M13 3.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0v-13Z" })));
});
